import HistoryOutlinedIcon from "@material-ui/icons/HistoryOutlined";
import { StateTripsList } from "./StateTripsList";

export default {
  icon: HistoryOutlinedIcon,
  list: StateTripsList,
};
